import type { BadgeColors } from '@kluein/klue-ui';

const getOutcomeBadgeColor = (outcomeLabel?: string): BadgeColors => {
  switch (outcomeLabel?.toLowerCase()) {
    case 'win':
      return 'green';
    case 'loss':
      return 'red';
    case 'churn':
      return 'orange';
    case 'churn_positive':
      return 'blue';
    default:
      return 'grey';
  }
};

export default getOutcomeBadgeColor;
